
/**
 * @template T 
 * @param { T } loader - vue 3 defineAsyncComponent 参数
 * @returns { T }
 */
export default function defineAsyncComponent(loader){
    return loader;
}